import type { RouteRecordRaw } from 'vue-router';

import { Layouts } from '@/layouts/constants/Layout';
import { RouteNames } from '@/router/constants/routeName';

const adminRoutes: RouteRecordRaw[] = [
  {
    path: '/users',
    name: RouteNames.Users,
    component: () => import('@/views/users/ListUsersOverview.vue'),
    meta: {
      layout: Layouts.MODERN,
    },
  },
  {
    path: '/users/deprecated',
    name: RouteNames.DeprecatedUsers,
    component: () => import('@/views/deprecated/UsersView.vue'),
  },
  {
    path: '/version',
    name: RouteNames.Version,
    component: () => import('@/views/VersionView.vue'),
    meta: {
      public: true,
    },
  },
];

export default adminRoutes;
